<template>
  <div class="relative px-4 pt-16 pb-20 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
    <div class="relative mx-auto max-w-7xl">
      <h2
        class="text-2xl font-bold leading-9 tracking-tight text-center  tmsk-blue-text"
      >
        Processing Payment
      </h2>
      <div class="grid max-w-lg gap-4 mx-auto mt-12">
        <div class="flex flex-row items-center justify-center">
          <img class="w-24" :src="getAssets(method.imageUrl)" />
        </div>
        <div class="flex flex-row items-center justify-center mt-4 text-center">
          Please complete your payment within 5 minutes.
        </div>
        <div class="flex flex-row items-center justify-center mt-10">
          <div class="w-20 h-20 border-4 border-teal-100 rounded-full loader" />
        </div>
        <p class="mt-4 text-center tmsk-blue-text">
          Please do not close this page as we process your payment
        </p>
        <p class="mt-4 text-center tmsk-blue-text">
          If you do not have the OCBC Pay Anyone app, please install it or
          change your payment method
        </p>
        <span class="flex w-full mt-6 rounded-full shadow-sm">
          <button
            type="button"
            class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white border border-transparent rounded-full  tmsk-blue-bg focus:outline-none sm:text-sm sm:leading-5"
            @click="handleCancellation"
          >
            Change Payment Method
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import beepAPI from '@/mixins/beepAPI'
import { mapActions } from 'vuex'
export default {
  name: 'PayAnyone',
  components: {},
  mixins: [beepAPI],
  props: {
    uuid: {
      type: String,
      required: true
    },
    method: {
      type: Object,
      required: true
    },
    expiryTimestamp: {
      type: Number,
      required: true
    },
    paymentUrl: {
      type: String,
      default: ''
    },
    qr: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      hasTimeout: false,
      allowCancel: false,
      countdownTimer: 30,
      redirectUrl: '',
    }
  },
  computed: {},
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    if (this.qr && !this.$cookies.get('sm6-pa-redirect')) this.redirectToPayment(this.qr)
    this.commencePolling()
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    ...mapActions(['updateSuccessfulPurchase']),

    commencePolling () {
      const body = {
        uuid: this.uuid,
        expiryTimestamp: this.expiryTimestamp
      }

      this.getPaymentStatus(body)
        .then(
          async response => {
            console.log(response)
            const { status } = response
            if (status === 'success') {
              this.$cookies.remove('sm6-pa-redirect')
              await this.updateSuccessfulPurchase(response)
              this.$emit('success')
            } else if (status === 'cancelled') {
              console.log('cancelled')
              if (!this.hasTimeout) {
                this.hasTimeout = true
                this.createModal({
                  title: 'Something went wrong',
                  message: 'Transaction has timed-out or was cancelled, We\'re redirecting back to your Order Summary.',
                  btnMessage: 'Proceed',
                  callback: () => {
                    this.$cookies.remove('sm6-pa-redirect')
                    this.$emit('failed')
                  }
                })
              }
            } else {
              setTimeout(this.commencePolling, 500)
            }
          },
          (error) => {
            if (!error.response || error.response.status === 0) {
              this.commencePolling()
            } else {
              this.createModal({
                title: 'Something went wrong',
                message: 'Transaction has timed-out or was cancelled, We\'re redirecting back to your Order Summary.',
                btnMessage: 'Proceed',
                callback: () => {
                  this.$cookies.remove('sm6-pa-redirect')
                  this.$emit('failed')
                }
              })
            }
          }
        )
    },

    getAssets (img) {
      if (!img) return
      if (img.substring(0, 4) === 'http') return img
      return require('@/assets/img/' + img)
    },

    getOperatingSystem() {
      const useragent = navigator.userAgent
      if (/[Aa]ndroid/.test(useragent)) {
        console.log('android')
        return 'android'
      } else if (/iPad|iPhone|iPod/.test(useragent) && !window.MSStream) {
        return 'ios'
      } else {
        return 'default'
      }
    },

    getBrowserAppID() {
      const useragent = navigator.userAgent
      if (/SamsungBrowser/.test(useragent)) {
        console.log('samsung')
        return { appID: 'com.sec.android.app.sbrowser', shouldOpenInExternalBrowser: 'false'}
      } else if (/Chrome/.test(useragent)) {
        console.log('chrome')
        return { appID: 'com.android.chrome', shouldOpenInExternalBrowser: 'false'}
      } else if (/Firefox/.test(useragent)) {
        console.log('firefox')
        return { appID: 'org.mozilla.firefox', shouldOpenInExternalBrowser: 'false'}
      } else if (/Opera/.test(useragent)) {
        console.log('opera')
        return { appID: 'com.opera.mini.native', shouldOpenInExternalBrowser: 'false'}
      } else {
        console.log('default')
        return { appID: '', shouldOpenInExternalBrowser: 'true'}
      }
    },

    redirectToPayment (qr) {
      let deeplink = ''
      const { appID } = this.getBrowserAppID()
      // const { appID, shouldOpenInExternalBrowser } = this.getBrowserAppID()
      // this.$rollbar.debug(`Session appID: ${appID}, shouldOpenInExternalBrowser: ${shouldOpenInExternalBrowser}, userAgent: ${navigator.userAgent}`)
      // const encoded = encodeURIComponent(window.location.search)
      // const returnURI = window.location.origin + window.location.pathname + `/?encoded=${encoded}`
      const os = this.getOperatingSystem()
      if (os === 'ios') {
        // deeplink = `ocbcpao://readQR?version=3&qrString=${qr}&transactionID=PAYTEST123&returnURI=${returnURI}&shouldOpenInExternalBrowser=${shouldOpenInExternalBrowser}`
        // deeplink = `ocbcpao://readQR?version=3&qrString=${qr}&transactionID=PAYTEST123&shouldOpenInExternalBrowser=${shouldOpenInExternalBrowser}`
        deeplink = `ocbcpao://readQR?version=3&qrString=${qr}&transactionID=PAYTEST123&shouldOpenInExternalBrowser=false`
      } else {
        // deeplink = `ocbcpao://readQR?version=3&qrString=${qr}&transactionID=PAYTEST123&appID=${appID}&intentAction=android.intent.action.SEND&returnURI=${returnURI}&shouldOpenInExternalBrowser=${shouldOpenInExternalBrowser}`
        // deeplink = `ocbcpao://readQR?version=3&qrString=${qr}&transactionID=PAYTEST123&appID=${appID}&intentAction=android.intent.action.SEND&shouldOpenInExternalBrowser=${shouldOpenInExternalBrowser}`
        deeplink = `ocbcpao://readQR?version=3&qrString=${qr}&transactionID=PAYTEST123&appID=${appID}&intentAction=android.intent.action.SEND&shouldOpenInExternalBrowser=false`
      }
      this.redirectUrl = deeplink

      if (this.$cookies.get('sm6-pa-redirect') !== deeplink) {
        this.$cookies.set('sm6-pa-redirect', deeplink, 60 * 5)
        window.location.href = deeplink
      }
    },

    async handleCancellation () {
      try {
        await this.putCancelTransaction({ uuid: this.uuid })
        this.createModal({
          title: 'Something went wrong',
          message: 'Transaction has timed-out or was cancelled, We\'re redirecting back to your Order Summary.',
          btnMessage: 'Proceed',
          callback: () => {
            this.$emit('failed')
          }
        })
      } catch (error) {
        this.createModal({
          title: 'Something went wrong',
          message: 'Transaction has timed-out or was cancelled, We\'re redirecting back to your Order Summary.',
          btnMessage: 'Proceed',
          callback: () => {
            this.$cookies.remove('sm6-pa-redirect')
            this.$emit('failed')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.loader {
  border-top-color: #16bdca;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
